"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlitzEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _types = require("../com/types");
var _types2 = require("../balance/types");
var _types3 = require("./types");
var _actions = require("../sound/actions");
var _types4 = require("../sound/types");
var _types5 = require("../ui/types");
var _types6 = require("../game/types");
var _GameStatus = require("../enums/GameStatus");
var _DialogState = require("../../../ui/enums/DialogState");
var _CommandType = require("../../dovahzul/CommandType");
var _BlitzStartRequest = require("../../dovahzul/requests/BlitzStartRequest");
var _BlitzStopRequest = require("../../dovahzul/requests/BlitzStopRequest");
var _CollectRequest = require("../../dovahzul/requests/CollectRequest");
var _SpinRequest = require("../../dovahzul/requests/SpinRequest");
var _RoundState = require("../enums/RoundState");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BlitzEpic = exports.BlitzEpic = /*#__PURE__*/_createClass(function BlitzEpic() {
  var _this = this;
  _classCallCheck(this, BlitzEpic);
  _defineProperty(this, "SLOW_SERVER_RESPONSE_TIMEOUT", 8000);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.commandSpinResponse, _this.commandRoundEndResponse, _this.commandPayLineWinResponse, _this.blitzRoundResult, _this.blitzPlayStart, _this.blitzPlayStop, _this.blitzStopResponse, _this.blitzStartRound, _this.blitzButtonPress, _this.blitzOn, _this.blitzOff, _this.blitzRoundStart,
    //  this.onReconnectStop, test with new cluster support
    _this.blitzFeaturePlay, _this.featureWinCounting, _this.featureWinCountingV2, _this.commandRoundEndNoneBlitzStats
    //  this.commandDEBUG
    );
  });
  /**
    *
    * Progress Command Queue on SpinResponse command.
    
  private commandDEBUG: Epic<any, any, any> = (
    action$,
    store: StateObservable<AppState>
  ) =>
    action$.pipe(
      ofType(COMMAND_RECEIVED),
      filter(
        (a) =>
        (CommandType.RoundStartResponse === a.payload.type ||
          CommandType.RoundEndResponse === a.payload.type)
      ),
      mergeMap(a => {
          switch (a.payload.type) {
          case CommandType.RoundStartResponse:
            console.warn('START')
            break;
          case CommandType.RoundEndResponse:
            console.warn('END')
            break;
          default:
            break;
        }
          return EMPTY
      })
    );*/
  /**
   *
   * Progress Command Queue on SpinResponse command.
   */
  _defineProperty(this, "commandSpinResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return store.value.blitz.on && (_CommandType.CommandType.SpinResponse === a.payload.type || _CommandType.CommandType.FeatureEndResponse === a.payload.type || _CommandType.CommandType.PayLineEndResponse === a.payload.type || _CommandType.CommandType.PayWayEndResponse === a.payload.type || _CommandType.CommandType.SpinEndResponse === a.payload.type);
    }), (0, _operators.mapTo)({
      type: _types.COMMAND_QUEUE_NEXT
    }));
  });
  /**
   *
   * Progress Command Queue on RoundEndResponse command.
   */
  _defineProperty(this, "commandRoundEndResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return store.value.blitz.on && _CommandType.CommandType.RoundEndResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      var command = a.payload;
      var actions = [(0, _rxjs.of)({
        type: _types3.BLITZ_ROUND_RESULT,
        payload: {
          totalCoinsWon: a.payload.totalCoinsWon,
          totalWon: store.value.bet.denomination * a.payload.totalCoinsWon
        }
      }), (0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      })];
      if (command.totalCoinsWon > 0) actions.push((0, _rxjs.of)((0, _actions.playSound)(_types4.SoundPack.Shared, false, _types4.BlitzSounds.WinExplosion)));
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  /**
    *
    * handle round end when blitz is off to handle stats.
    * Make sure replays/demos dont count
    */
  _defineProperty(this, "commandRoundEndNoneBlitzStats", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types6.ROUND_END), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && !store.value.replay.playingReplay;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types3.BLITZ_STATS_UPDATE,
        payload: {
          totalWon: a.payload.totalWon,
          totalCoinsWon: a.payload.totalCoinsWon
        }
      });
    }));
  });
  /**
   *
   * Progress Command Queue on PayLineWinResponse command.
   */
  _defineProperty(this, "commandPayLineWinResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return store.value.blitz.on && (_CommandType.CommandType.PayLineWinResponse === a.payload.type || _CommandType.CommandType.PayWayWinResponse === a.payload.type);
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types3.BLITZ_PAYLINE_WIN,
        payload: a.payload.coinsWon
      }), (0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      }));
    }));
  });
  _defineProperty(this, "blitzRoundResult", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_ROUND_RESULT), (0, _operators.mergeMap)(function () {
      if (store.value.blitz.roundsLeft > 0) {
        // Check time left since last round.
        var msWait = 100;
        if (store.value.blitz.roundStarted != undefined) msWait = store.value.blitz.minRoundTime - (new Date().getTime() - store.value.blitz.roundStarted.getTime());
        if (msWait < 0) msWait = 0;
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types.COMMAND_SEND,
          payload: new _CollectRequest.CollectRequest()
        }), (0, _rxjs.of)({
          type: _types3.BLITZ_START_ROUND
        }).pipe((0, _operators.delay)(msWait), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_PLAY_STOP)))));
      } else {
        // no more rounds left.
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types.COMMAND_SEND,
          payload: new _CollectRequest.CollectRequest()
        }), (0, _rxjs.of)({
          type: _types3.BLITZ_PLAY_STOP
        }));
      }
    }));
  });
  /**
   * Trigger first round to be played once the player wants to start playing blitz rounds.
   */
  _defineProperty(this, "blitzPlayStart", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_PLAY_START), (0, _operators.filter)(function () {
      return store.value.blitz.on && store.value.config.blitzAllowed;
    }), (0, _operators.mergeMap)(function (a) {
      var bet = store.value.bet;

      /// balance check, skip if there is no promo.
      if (store.value.balance.balance && store.value.bet.centValue > store.value.balance.balance.centValue && !store.value.promotion.on) {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types3.BLITZ_PLAY_STOP
        }), (0, _rxjs.of)({
          type: _types5.DIALOG_STATE,
          payload: _DialogState.DialogState.INSUFFICIENT_BALANCE
        }), (0, _rxjs.of)({
          type: _types3.BLITZ_PLAY_START_RESPONDED
        }));
      }
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.COMMAND_SEND,
        payload: new _BlitzStartRequest.BlitzStartRequest(bet.coins, bet.lines, bet.denomination, {
          blitz: true
        }, a.payload)
      }));
    }));
  });
  _defineProperty(this, "blitzRoundStart", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return store.value.blitz.on && _CommandType.CommandType.BlitzStartResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types3.BLITZ_PLAY_START_RESPONDED
      }), (0, _rxjs.of)({
        type: _types3.BLITZ_START_ROUND
      }), (0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      }));
    }));
  });
  _defineProperty(this, "blitzStopResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.BlitzStopResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types3.BLITZ_PLAY_STOP_RESPONDED
      }), (0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      }));
    }));
  });
  _defineProperty(this, "blitzPlayStop", function (action$, store) {
    return action$.pipe((0, _operators.filter)(function () {
      return store.value.blitz.on;
    }), (0, _reduxObservable.ofType)(_types3.BLITZ_PLAY_STOP), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.COMMAND_SEND,
        payload: new _BlitzStopRequest.BlitzStopRequest()
      })
      /*      of(playSound(Sound.BlitzBg, false, 'intro')),
                      of(playSound(Sound.BlitzBg, false, 'spinsEnd'))
                          .pipe(delay(1250), // SO ANNOYING AND ERROR PRONE. not sure how to best do this.
                              takeUntil(action$.ofType(BLITZ_MODE_OFF))
                          )*/);
    }));
  });
  _defineProperty(this, "blitzStartRound", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_START_ROUND), (0, _operators.filter)(function () {
      return store.value.blitz.playing;
    }), (0, _operators.mergeMap)(function () {
      var bet = store.value.bet;
      if (store.value.blitz.roundState == _RoundState.RoundState.Started) {
        console.warn('Round not ended, will not start new.');
        return _rxjs.EMPTY;
      }
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types3.BLITZ_ROUND_STARTED
      }), (0, _rxjs.of)({
        type: _types2.UPDATE_BALANCE_BET,
        payload: bet.value
      }), (0, _rxjs.of)({
        type: _types.COMMAND_SEND,
        payload: new _SpinRequest.SpinRequest(bet.coins, bet.lines, bet.denomination, {
          blitz: true
        }, null, bet.featureSet)
      }), (0, _rxjs.of)({
        type: _types6.SLOW_SERVER_RESPONSE
      }).pipe((0, _operators.delay)(_this.SLOW_SERVER_RESPONSE_TIMEOUT), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED)))));
    }));
  });
  _defineProperty(this, "blitzOff", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_MODE_OFF), (0, _operators.mergeMap)(function () {
      var actions = [(0, _rxjs.of)({
        type: _types6.SET_SAVED_REELS
      }), (0, _rxjs.of)((0, _actions.fadeSound)(_types4.SoundPack.Game, _types4.GameSounds.BgStem1, null, 1, 1000)), (0, _rxjs.of)((0, _actions.stopSound)(_types4.SoundPack.Shared, 500, _types4.BlitzSounds.Start)), (0, _rxjs.of)((0, _actions.stopSound)(_types4.SoundPack.Shared, 500, _types4.BlitzSounds.NormalLoop))];
      if (store.value.game.gameStatus != _GameStatus.GameStatus.Running) actions.push((0, _rxjs.of)({
        type: _types5.STATUS_TEXT_SET,
        payload: {
          value: ""
        }
      })); // THIS FUCKS RECONNECTS AND SHOWING CORRECT WIN AMOUTN

      if (!store.value.autoPlay.on) actions.push((0, _rxjs.of)({
        type: _types5.SHOW_SPIN_BUTTON
      }));
      if (store.value.com.storedFeatureCommand) {
        var command = store.value.com.storedFeatureCommand;
        command.payload.repeated = true;
        actions.push((0, _rxjs.of)(command, {
          type: _types.COMMAND_FEATURE_STORE_CLEAR
        }));
      }
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "blitzOn", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_MODE_ON), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)((0, _actions.fadeSound)(_types4.SoundPack.Game, _types4.GameSounds.BgStem1, null, 0.2, 1000)), (0, _rxjs.of)({
        type: _types5.HIDE_SPIN_BUTTON
      }), (0, _rxjs.of)({
        type: _types5.SET_IDLE_TEXT,
        payload: {}
      }),
      // remove any game idle text set.

      (0, _rxjs.of)((0, _actions.playSound)(_types4.SoundPack.Shared, false, _types4.BlitzSounds.WinSpark)), (0, _rxjs.of)((0, _actions.playSound)(_types4.SoundPack.Shared, false, _types4.BlitzSounds.Start)), (0, _rxjs.of)((0, _actions.playSound)(_types4.SoundPack.Shared, false, _types4.BlitzSounds.NormalLoop)).pipe((0, _operators.delay)(1990),
      // SO ANNOYING AND ERROR PRONE. not sure how to best do this.
      (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_MODE_OFF)))));
    }));
  });
  _defineProperty(this, "blitzButtonPress", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types5.BLITZ_BUTTON), (0, _operators.filter)(function () {
      return !store.value.blitz.locked && store.value.blitz.on && store.value.ui.dialogState == _DialogState.DialogState.CLOSED;
    }), (0, _operators.mergeMap)(function () {
      if (store.value.blitz.splashScreen) {
        return (0, _rxjs.of)({
          type: _types3.BLITZ_CLOSE_SPLASH
        });
      }
      // we are already playing, or there is a previous starting pending don't trigger.
      else if (!store.value.blitz.playing && !store.value.blitz.starting) {
        //Extra protection added to prevent GAME NOT IDLE ISSUE
        // happens with slow response on rounds played.
        if (store.value.blitz.roundState == _RoundState.RoundState.Started) {
          console.warn('BLITZ round NOT ENDED, WONT START NEW Blitz');
          return _rxjs.EMPTY;
        }

        // if we are in a promotion state, set rounds to be the amount of free rounds that are left.
        return (0, _rxjs.of)({
          type: _types3.BLITZ_PLAY_START,
          payload: store.value.promotion.roundsLeft ? store.value.promotion.roundsLeft : store.value.blitz.rounds
        });
      } else if (!store.value.blitz.stopping) {
        return (0, _rxjs.of)({
          type: _types3.BLITZ_PLAY_STOP
        });
      } else {
        console.log("Waiting for GameServer to respond");
        return _rxjs.EMPTY;
      }
    }));
  });
  _defineProperty(this, "blitzFeaturePlay", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.BLITZ_PLAY_FEATURE), (0, _operators.filter)(function () {
      return store.value.blitz.on;
    }), (0, _operators.mergeMap)(function (a) {
      if (store.value.blitz.skipFeature) {
        return (0, _rxjs.of)({
          type: _types3.BLITZ_FEATURE_SKIP
        }, {
          type: _types3.BLITZ_PLAY_UNPAUSE
        }, {
          type: _types.COMMAND_QUEUE_NEXT
        }, {
          type: _types3.BLITZ_FEATURE_COUNT
        });
      }
      var actions = [(0, _rxjs.of)((0, _actions.playSound)(_types4.SoundPack.Shared, false, _types4.BlitzSounds.PachiTripple, 1)), (0, _rxjs.of)({
        type: _types3.BLITZ_PLAY_PAUSE
      })];
      // special flag to avoid this command to count twice in certain places.
      a.payload.payload.RESENT = true;
      actions.push((0, _rxjs.of)({
        type: _types5.REQUEST_DIALOG_STATE_ACTIONS,
        payload: {
          state: _DialogState.DialogState.BLITZ_FEATURE,
          actions: {
            DIALOG_NO: [{
              type: _types3.BLITZ_FEATURE_SKIP
            }, {
              type: _types3.BLITZ_PLAY_UNPAUSE
            }, {
              type: _types.COMMAND_QUEUE_NEXT
            }, {
              type: _types3.BLITZ_FEATURE_COUNT
            }],
            DIALOG_OK: [{
              type: _types3.BLITZ_PLAY_STOP
            }, {
              type: _types3.BLITZ_MODE_OFF
            },
            // we provide a tag to the round start action, so we can check if it was called from a blitz feature beeing played in classic mode.
            {
              type: _types6.ROUND_START,
              payload: "blitzPlayClassic"
            },
            // so round wont count twice
            {
              type: _types3.BLITZ_ROUND_DEDUCT
            },
            // this shows line wins onto the win counter. if not the big win and counter wont show the wins from regular paylines if there where any.
            {
              type: _types6.GAME_WINCOUNTER_SET,
              payload: store.value.blitz.roundNormalCoinsWon
            },
            // Resend the action
            a.payload]
          }
        }
      }));
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  // ITS BEACUSE THE COMMAND IS ACTUALLY SENT TWICE WHEN CHOOSING CLASSIC!!!!!! FRUUUUUUUUCK
  _defineProperty(this, "featureWinCounting", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.FeatureWinResponse === a.payload.type && !a.payload.RESENT // special flag to avoid this command to count twice in certain places.
      && a.payload.coinsWon > 0 && a.payload.awardType < 5000;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types3.BLITZ_FEATURE_WON,
        payload: {
          totalWon: a.payload.coinsWon * store.value.bet.denomination,
          totalCoinsWon: a.payload.coinsWon
        }
      });
    }));
  });
  _defineProperty(this, "featureWinCountingV2", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY),
    // special flag to avoid this command to count twice in certain places.
    (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.FeatureEndResponse === a.payload.type && a.payload.coinsWon > 0 && a.payload.awardType < 5000;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types3.BLITZ_FEATURE_WON,
        payload: {
          totalWon: a.payload.coinsWon * store.value.bet.denomination,
          totalCoinsWon: a.payload.coinsWon
        }
      });
    }));
  });
});
//# sourceMappingURL=epics.js.map